export const CACHE_EXCLUSIONS = [
    '/_nuxt',
    '/_loading',
    '/_ipx',
    '/media/',
    '/compare',
    '/en/compare',
    '/ro/compare',
    '/ru/compare',
    '/favorites',
    '/en/favorites',
    '/ro/favorites',
    '/ru/favorites'
];
